import * as Yup from 'yup';
import moment from 'moment';
import createCustomer from './createCustomerFormModel';
const {
  formField: {
    // DATOS CLIENTE
    name,
    address,
    email,
    person_in_charge,
    contact,
    second_person_in_charge,
    second_customer_contact,
    phone,
    start_date,
    status,
    country,
    departament,
    municipaly,
    applications,
    has_trial,
    trial_ends_at,
    subscription_ends_at,
  },
} = createCustomer;

export default [
  // INFORMACION BASICA
  Yup.object().shape({
    [name.name]: Yup.string().required(`${name.requiredErrorMsg}`),
    [address.name]: Yup.string().required(`${address.requiredErrorMsg}`),
    [email.name]: Yup.string()
      .required(`${email.requiredErrorMsg}`)
      .email(`${email.requiredErrorMsg}`),
    [person_in_charge.name]: Yup.string().required(`${person_in_charge.requiredErrorMsg}`),
    [contact.name]: Yup.number()
      .typeError('El contacto debe ser numerico')
      .label(`${contact.typeDataMsg}`)
      .required(`${contact.requiredErrorMsg}`),
    [second_person_in_charge.name]: Yup.string().optional(),
    [second_customer_contact.name]: Yup.number()
      .typeError('El contacto debe ser numerico')
      .label(`${second_customer_contact.typeDataMsg}`)
      .optional(),
    [phone.name]: Yup.string().required(`${phone.requiredErrorMsg}`),
    [start_date.name]: Yup.string().required(`${start_date.requiredErrorMsg}`),
    [status.name]: Yup.boolean(),
    [country.name]: Yup.object()
      .shape({
        value: Yup.string().required(),
        label: Yup.string().required(),
      })
      .default(undefined) // 👈
      .required(`${country.requiredErrorMsg}`),
    [departament.name]: Yup.object()
      .shape({
        value: Yup.string().required(),
        label: Yup.string().required(),
      })
      .default(undefined) // 👈
      .required(`${departament.requiredErrorMsg}`),
    [municipaly.name]: Yup.object()
      .shape({
        value: Yup.string().required(),
        label: Yup.string().required(),
      })
      .default(undefined) // 👈
      .required(`${municipaly.requiredErrorMsg}`),

    [applications.name]: Yup.lazy((value) => {
      if (Array.isArray(value)) {
        // Multiple
        return Yup.array()
          .of(
            Yup.object().shape({
              value: Yup.string().required(),
              label: Yup.string().required(),
            })
          )
          .min(1, applications.requiredErrorMsg);
      }
      // Simple
      return Yup.object()
        .shape({
          value: Yup.string().required(),
          label: Yup.string().required(),
        })
        .nullable()
        .required(applications.requiredErrorMsg);
    }),
    [has_trial.name]: Yup.boolean(),
    [trial_ends_at.name]: Yup.string()
      .nullable()
      .when(has_trial.name, {
        is: true,
        then: (schema) => schema.required(`${trial_ends_at.requiredErrorMsg}`),
        otherwise: (schema) => schema.notRequired(),
      }),
    [subscription_ends_at.name]: Yup.string()
      .nullable()
      .when(has_trial.name, {
        is: false,
        then: (schema) => schema.required(`${subscription_ends_at.requiredErrorMsg}`),
        otherwise: (schema) => schema.notRequired(),
      }),
  }),
];
